export const MAINSLIDER_TYPES = {
  image: 'image',
  video: 'video',
};
